<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      <fa-icon [icon]="faUsers" />
      Loan Status Report
    </h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="content-container">
    <app-data-form [dataFields]="FormFields" />
    <div class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
      <button class="shorter-btn misc-btn" (click)="Print()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
    </div>
  </div>
</section>
